<template>
    <div v-if="stage" class="px-4">
        <v-row>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Ruta al email: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.email_location"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.email_location"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    v-model="stage.template_code"
                    label="Código de plantilla"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.template_code"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Contexto: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.context_location"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        
    </div>
</template>

<script>
import { SendEmailWithTemplate } from '@/modules/document/domain/WorkflowTemplate';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import RouteInBagSelectorComponent from '@/modules/document/infra/RouteInBagSelectorComponent';

export default {
    name:'SendEmailWithTemplateDetailComponent',
    components: {
        RouteInBagSelectorComponent
    },
    props:{
        stage: {
            type: SendEmailWithTemplate,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        my_bag: {
            type: Object,
            default: () => {}
        }
    },
    data(){
        return {
        }
    },
    mounted(){
        console.log(this.stage);
    },
    methods:{
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        computeStage(){
            this.$emit('compute-stage');
        }
    },
    computed:{
        
    },
    beforeDestroy() {
        // Remove the stylesheet when the component is destroyed
        // if (this.cssLink && document.head.contains(this.cssLink)) {
        // document.head.removeChild(this.cssLink);
        // }
    }
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>